import GridContainer from '@ulta/core/components/GridContainer/GridContainer';

export default GridContainer;
